<template>
	<div class="marketingProjectEditor">
		<realTaskmenu class="realTaskmenu" v-on:cut="cut"></realTaskmenu>
		<div class="userTable">
			<div class="userTableBtn" style="">
				<el-button style="margin: 10px 20px;padding: 0px 15px;" size="mini" type="primary" @click="back()">返回
				</el-button>
				<div>
					<el-button style="margin: 10px 20px" :disabled="initializeUser.length>0?false:true" size="mini" type="primary" plain @click="initialize()">初始化
					</el-button>
					<el-button style="margin: 10px 20px" size="mini" type="primary" plain @click="addStuStaff()">添加学生为员工
					</el-button>
					<el-button style="margin: 10px 20px" size="mini" type="primary" plain @click="Assigned_project()">
						分配项目
					</el-button>
				</div>

			</div>

			<div id="tableId">
				<el-table :data="UserList" stripe @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55" :selectable="selected">
					</el-table-column>
					<el-table-column type="index" label="序号" width="80">
						<template slot-scope="scope">
								<span>{{(totalObj.currentPage - 1) * totalObj.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="studentName" label="姓名" width="150">
					</el-table-column>
					<el-table-column prop="mobile" label="手机号" width="100">
            <template slot-scope="scope">
              <span style="color: #333333">{{scope.row.mobile | desensitizationText}}</span>
            </template>
					</el-table-column>
					<el-table-column prop="studentNumber" label="学号" width="150">
					</el-table-column>
					<el-table-column prop="companyId" label="所在自然班" width="120">
					</el-table-column>
					<el-table-column prop="projectName" label="分配的项目">
					</el-table-column>
					<el-table-column prop="assistProject" label="数据初始化状态">
						<template slot-scope="scope">
							<span>{{handleStatus(scope.row.status)}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120">
						<template slot-scope="scope">
							<el-button @click="delstu(scope.row)" size="mini" v-if="scope.row.status == 0"> 删除 </el-button>
						</template>
					</el-table-column>
				</el-table>
				<!-- 班级公司管理分页 -->
				<div class="selectePages">
					<el-pagination @size-change="classCompanySizeChange" @current-change="classCompanyCurrentChange"
						:current-page.sync="totalObj.currentPage" background :page-sizes="[10, 20, 50, 100]"
						:page-size="totalObj.pageSize" layout="sizes, prev, pager, next" :total="totalObj.total">
					</el-pagination>
				</div>
			</div>
		</div>

		<div v-if="Transfer == 1">
			<el-dialog title="添加学生" custom-class="add_stu" center width="982px" :show-close="false"
				:visible.sync="centereDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false"
				:before-close="add_all_student_cancel">
				<div class="sudent-contents">
					<!-- 待选 -->
					<div class="sudent-content">
						<div class="selected tobe">
							<div class="seach">
								<span>待选</span>
								<div class="training-site">
									<el-input v-model="queryVal" placeholder="请输入姓名/学号/手机号/账号" size="mini"
										style="width: 200px; height: 28px; float: left"
										@keyup.enter.native="search_student">
										<i slot="suffix" @click="search_student"
											class="el-input__icon el-icon-search"></i>
									</el-input>
									<el-select v-model="teachingClass" @change="teachingClassChange"
										placeholder="请选择行政班" clearable>
										<el-option v-for="(item, key) in options" :key="key" :label="item"
											:value="item">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="left-table">
								<el-table ref="multipleTable2" :data="tableData_3" :cell-style="cellStyle3"
									:header-cell-style="headerCellStyle3" :row-style="{ border: 0 }" style="width: 100%"
									height="256px" :row-key="getRowKey" @selection-change="check_student">
									<el-table-column width="50" type="selection" align="center"
										:reserve-selection="true"></el-table-column>
									<el-table-column prop="name" label="姓名"></el-table-column>
									<el-table-column prop="studentNumber" label="学号"></el-table-column>
									<el-table-column prop="teachingClass" label="行政班"></el-table-column>
								</el-table>
							</div>
							<!-- 分页 -->
							<div class="selecteStudentPages">
								<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
									:current-page.sync="currentPage2" background :page-sizes="[10, 20, 50, 100]"
									:page-size="pageSize" :pager-count="5" layout="total, prev, pager, next"
									:total="studentTotal"></el-pagination>
							</div>
						</div>
						<!-- button  -->
						<div class="box_button">
							<el-button type="primary" @click="add_active" :disabled="!table_student.length"
								class="button_top" icon="el-icon-arrow-right" circle></el-button>
							<el-button type="primary" @click="remove_active" :disabled="!table_student2.length"
								icon="el-icon-arrow-left" circle></el-button>
						</div>
						<!-- 已选 -->
						<div class="selected">
							<div class="seach">
								<span>已选</span>
								<div class="training-site">
									<el-input v-model="queryVal2" placeholder="请输入姓名/学号/手机号/账号" size="mini"
										style="width: 210px; height: 28px"
										@keyup.enter.native="query_student2(queryVal2)">
										<i slot="suffix" @click="query_student2(queryVal2)"
											class="el-input__icon el-icon-search"></i>
									</el-input>
								</div>
							</div>
							<div class="">
								<el-table :data="tagList" :cell-style="cellStyle3" :header-cell-style="headerCellStyle3"
									:row-style="{ border: 0 }" style="width: 100%" height="301px"
									@selection-change="check_student2">
									<el-table-column width="50" type="selection" align="center"></el-table-column>
									<el-table-column prop="name" label="姓名"></el-table-column>
									<el-table-column prop="studentNumber" label="学号"></el-table-column>
									<el-table-column prop="teachingClass" label="行政班"></el-table-column>
								</el-table>
							</div>
						</div>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="add_all_student_cancel">取 消</el-button>
					<el-button type="primary" @click="add_all_student">确 定</el-button>
				</span>
			</el-dialog>
		</div>
		<div v-if="StuStaff == 1">
			<el-dialog title="分配项目" :visible.sync="dialogVisible" width="926px" border-radius="25px">
				<span>
				</span>
				<div v-for="(item, index) in subjectIds" :key="index">
					<div style="
                border: #e6e8f1 1px solid;
                display: flex;
                flex-direction: column;
              ">
						<span style="margin: 0px 0 5px 0; justify-content: space-between">
							<div style="
                    width: 100%;
                    height: 30px;
                    background-color: #e6e8f1;
                    display: flex;
                    align-items: center;
                  ">
								<span>{{item.projectName}}</span>
							</div>

							<div style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  ">
								<span>指派给:</span>
								<el-button size="mini" style="border: none; background-color: white"
									slot="reference"><i style="font-size: 20px" class="el-icon-circle-plus-outline"
										@click="addstu(item)"></i></el-button>
								<el-dialog
									width="450px"
									title="选择学员"
									:visible.sync="item.innerVisible"
									append-to-body>
									<div class="inner_wrap">
										<el-input v-model="mobileName" placeholder="手机号/姓名" @keyup.enter.native="getStuList(item)"></el-input>
										<div class="stu_list">
											<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
											<el-checkbox-group style="display: flex; flex-direction: column"
												v-model="checkedStus" @change="handleCheckedChange">
												<el-checkbox v-for="(a, id) in stuList" :key="id" :label="a.studentUserId">{{a.studentName}}</el-checkbox>
											</el-checkbox-group>
										</div>
									</div>
									<span slot="footer" class="dialog-footer">
										<el-button @click="handleStu(false,item)">取 消</el-button>
										<el-button type="primary" @click="handleStu(true,item)">确 定</el-button>
									</span>
								</el-dialog>
							</div>
						</span>

						<span>
							<el-tag style="margin: 5px" v-for="tag in item.checkList" :key="tag.studentName" closable>
								{{ tag.studentName }}
							</el-tag>
						</span>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="addStuProject">确 定</el-button>
				</span>
			</el-dialog>
		</div>

	</div>
</template>

<script>
	import realTaskmenu from "../components/realTaskMenu";
	import * as api from "../../../api/marketingProjectManagement"; // 内容展示
	import router from '../../../router';
  import {desensitization} from "@/utils/utils";

	export default {
		// props:["classCompany"],
    filters:{
      desensitizationText(val){
        return desensitization(val)
      }
    },
		components: {
			realTaskmenu,
		},
		data() {
			return {
				professional: sessionStorage.getItem("professional"),
				selectCompanyId: "",
				select_projectList: [],
				projectList: [],
				checkList: [],
				tableData: [],
				classCompany: [],
				materialForm: {
					url: `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`,
					data: {
						savepath: "cjdd/resourse/",
					},
					fileName: "",
					id: this.$route.query.id,
				},
				centereDialogVisible: false,
				tagList: [],
				queryVal2: "",
				table_student: [], //  选中学生列表 待选
				table_student2: [], //  选中学生列表  选中
				studentTotal: 0,
				pageSize: 10,
				currentPage2: 0,
				border: "",
				tableData_3: [],
				options: "",
				teachingClass: "",
				queryVal: "",
				StuStaff: -1,
				Transfer: -1,
				selectedStudentList: [],
				queryStudentList: [],
				UserList: [],
				answerList: [], //单选题多选题的数据状态集合
				courseId: sessionStorage.getItem("courseId"),
				dialogVisible: false,
				pop_up_box: false,
				pageTotal: {
					pageSize: 0,
					currentPage: 0,
					total: 0,
				},
				totalObj: {
					pageSize: 10,
					currentPage: 1,
					total: 0,
				},
				id: this.$route.query.id,
				subjectId: this.$route.query.subjectId,
				subjectIds: [],
				companyName: "",
				companyContext: "",
				companyLogo: "",
				companyId: "",
				studentUserId: "",
				personnelManagement: 1,
				initializeUser: [],
				checkAll: false,
				isIndeterminate: true,
				innerVisible: false,
				stuList: [],
				checkedStus: [],
				mobileName: '',
				checkedList: []
			};

		},
		created() {
			this.init();
			this.getStudentList();
			this.getTeachingClass();
			this.personnelManagementFuntion();
		},
		mounted() {},
		computed: {
			headers() {
				return {
					Authorization: "bearer " + localStorage.getItem("Authorization"),
				};
			},
		},
		methods: {
			// 初始化
			initialize() {
				let params = {
					ids: this.initializeUser,
					status: 1,
				};
				api.updateStatus(params).then((res) => {
					if (res.code == 0) {
						this.personnelManagementFuntion(this.id)
						this.$messageSuccess("初始化成功！")
					}else{
						this.$messageError("初始化失败！")
					}
				})
			},
			handleSelectionChange(val) {
				this.initializeUser = []
				console.log(val);
				for (let index = 0; index < val.length; index++) {
					this.initializeUser.push(val[index].teamId
					)
				}

			},
			init() {
				this.params = {
					subjectId: this.id,
				};
				api.CompanyList(this.params).then((res) => {
					if (res.code == 0) {
						this.classCompany = res.data.records;
					}
				});

			},
			add_active() {
				// 添加到选中
				this.tagList = [];
				this.addStudentList = [];
				this.list_st = [];
				this.table_student.forEach((item) => {
					this.tagList.push(item);
					this.list_st.push(item);
					this.addStudentList.push(item);
				});
				this.table_student = [];
				this.query_student();
			},
			remove_active() {
				// 删除选中
				this.table_student2.forEach((items) => {
					this.tagList.forEach((item, i) => {
						if (items.id == item.id) {
							this.tagList.splice(i, 1);
							this.list_st.splice(i, 1);
						}
					});
					this.addStudentList.forEach((item, i) => {
						if (items.id == item.id) {
							this.addStudentList.splice(i, 1);
						}
					});
				});
				this.table_student2 = [];
				this.query_student();
			},
			cellStyle3(data) {
				if (data.columnIndex == 0) {
					return "text-algin:center !important;";
				} else {
					return "text-align:left !important;padding-left: 20px!important;";
				}
			},
			headerCellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0 && columnIndex === 0) {
					return "text-algin:center !important;";
				}
			},
			cellStyle(data) {
				if (data.columnIndex == 0) {
					return "text-algin:center !important";
				}
			},
			headerCellStyle3({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0 && columnIndex === 0) {
					return "background:rgba(83,151,247,0.1);color:#999999;text-algin:center !important;";
				} else {
					return "background:rgba(83,151,247,0.1);color:#999999;text-align:left !important;padding-left: 20px!important;";
				}
			},
			check_student2(list) {
				this.table_student2 = list;
			},
			add_all_student() {
				if (this.addStudentList.length) {
					let newArr = [];
					// console.log("选择的数据",this.addStudentList)
					// console.log("全部",this.table_student)
					this.addStudentList.forEach((item) => {
						var obj = {};
						obj.studentName = item.name;
						obj.studentNumber = item.studentNumber;
						obj.studentUserId = item.id;
						obj.className = item.teachingClass;
						obj.mobile = item.mobile;
						newArr.push(obj);
					});
					let data = {
						companyId: this.id,
						entityList: newArr,
					};
					api.Usersave(data).then(
						(data) => {
							if (data.code == 0) {
								this.centereDialogVisible = false;
								this.$messageSuccess("添加成功");
								this.personnelManagementFuntion(this.id); // 人事管理列表
								this.tagList = [];

								this.list_st = [];
								this.addStudentList = [];
							} else {
								this.$messageInfo(data.msg);
							}
						},
						(e) => {
							this.$messageError(e);
						}
					);
				} else {
					this.$messageInfo("请选择");
				}
			},

			search_student() {
				this.currentPage2 = 1;
				this.query_student();
			},
			getRowKey(row) {
				return row.id;
			},
			check_student(list) {
				// 选中待选
				this.table_student = list;
			},
			handleSizeChange2(val) {
				this.currentPage2 = 1;
				this.pageSize = val;
				this.query_student();
			},
			handleCurrentChange2(val) {
				this.currentPage2 = val;
				this.query_student();
			},
			teachingClassChange(val) {
				this.teachingClass = val;
				this.query_student();
			},
			add_all_student_cancel() {
				this.centereDialogVisible = false;
				this.queryVal = "";
				this.queryVal2 = "";
				this.currentPage2 = 1;
				this.addStudentList = [];
				this.query_student();
				this.pageSize = 10;
				this.$refs.multipleTable2.clearSelection();
			},
			open_dialog(a) {
				this.dialogVisible = true;
				this.companyName = a.companyName;
				this.companyContext = a.companyContext;
				this.companyLogo = a.companyLogo;
				this.id = a.id;
			},
			// 用公司id 获取公司下的学生
			personnelManagementFuntion(id) {
				this.companyId = id;
				let params = {
					companyId: this.id,
					pageSize: this.totalObj.pageSize,
					pageNo: this.totalObj.currentPage,
				};
				api.companyUserList(params).then((res) => {
					if (res.code == 0) {
						this.UserList = res.data.list;
						this.totalObj.total = res.data.total;
					}
				});
			},
			//保存
			handleSave() {
				this.dialogVisible = false;
				let params = {
					id: this.id,
					companyContext: this.companyContext,
					companyLogo: this.companyLogo,
					companyName: this.companyName,
					subjectId: this.subjectId,
				};
				if (this.id == "") {
					api.SaveCompany(params).then((res) => {
						if (res.code == 0) {
							this.init();
							this.$message({
								message: "新增成功",
								type: "success",
							});
							// this.answerList = res.data
						}
					});
				} else {
					api.updateCompany(params).then((res) => {
						if (res.code == 0) {
							this.init();
							this.$message({
								message: "修改成功",
								type: "success",
							});

							// this.answerList = res.data
						}
					});
				}
			},
			//删除
			del(a) {
				this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.id = a.id;
						let params = {
							id: this.id,
						};
						api.deleteCompany(params).then((res) => {
							if (res.code == 0) {
								this.init();
								// this.answerList = res.data
							}
						});
						this.$message({
							type: "success",
							message: "删除成功!",
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			handleAvatarSuccess(res, file) {
				if (res.code == 0) {
					this.companyLogo = res.data.newAttaUrl;
				} else {
					let fileId = file.uid;
					this.showUploadFileList.forEach((item) => {
						if (item.uid == fileId) {
							item.state = "上传失败";
						}
					});
					this.$message.error("格式不支持上传");
				}
			},
			addStuStaff() {
				this.currentPage2 = 1;
				this.query_student();
				this.centereDialogVisible = true;
				this.Transfer = 1;
			},
			Assigned_project() {
				this.dialogVisible = true;
				this.StuStaff = 1;
				this.subjectIds = [];
				let params = {
					id: this.id,
					// subjectId :$route.query.subjectId
				};
				api.findById(params).then((res) => {
					if (res.code == 0) {
						res.data.list.forEach((item) => {
							item.checkList = [];
							item.innerVisible = false
							this.subjectIds.push(item);
							this.subjectIds = [...new Set(this.subjectIds)]
						});
						this.getProjectUser()
					}else{
						this.$messageError(res.msg)
					}
				});
			},
			// 查询指派人员
			getProjectUser(){
				api.getProjectUser(this.id).then(res=>{
					if(res.code == 0){
						let list = res.data
						if(list && list.length){
							list.forEach(item=>{
								this.subjectIds.forEach(val=>{
									if(item.projectId == val.projectId){
										item.userResps.forEach(v=>{
											let obj = {}
											obj.studentName = v.nickName
											obj.studentUserId = v.userId
											val.checkList.push(obj)
										})
									}
								})
							})
						}
					}else{
						this.$messageError(res.msg)
					}
				})
			},
			// 查询所有的学员
			query_student() {
				// 查询学生
				let that = this;
				let obj = {
					limit: this.pageSize,
					page: that.currentPage2,
					name: that.queryVal,
					type: "2",
					status: "1",
					teachingClass: this.teachingClass,
				};
				api.getAllStudent(obj).then(
					(data) => {
						if (data.code == 0) {
							let datalist = data.data;
							console.log("asdasd", datalist);
							that.studentTotal = datalist.total;
							that.tableData_3 = [];
							datalist.records.forEach((item) => {
								that.tableData_3.push({
									userName: item.userName,
									name: item.name,
									studentNumber: item.studentNumber ? item.studentNumber : "--",
									teachingClass: item.teachingClass ? item.teachingClass : "--",
									id: item.userId,
									mobile: item.mobile,
								});
							});
							if (that.tagList.length) {
								that.tagList.forEach((items) => {
									that.tableData_3.forEach((item, i) => {
										if (items.id == item.id) {
											that.tableData_3.splice(i, 1);
										}
									});
								});
								let num = 0;
								that.tableData_3.forEach((v, i) => {
									if (v.flag) {
										num++;
									}
								});
								if (num == 10) {
									this.$refs.multipleTable.toggleAllSelection();
								}
							}
						} else {
							this.$messageInfo("没找到");
						}
					},
					(e) => {
						this.$messageError(e);
					}
				);
			},
			getStudentList() {
				let obj = {
					param: this.nameSum,
					className: this.className,
					classId: this.classId,
					page: this.pageTotal.currentPage,
					limit: this.pageTotal.pageSize,
					status: 1,
				};
				api
					.getStudentList(obj)
					.then((res) => {
						if (res.code == 0) {
							this.loading = false;
							this.tableData = res.data.list;
							this.pageTotal.total = res.data.total;
							this.pageTotal.currentPage = res.data.pageNum;
							if (res.data.total > 10) {
								this.height = window.innerHeight - 290 + "px";
							} else {
								this.height = window.innerHeight - 240 + "px";
							}
						} else {
							this.loading = false;
							this.$messageError(res.msg);
						}
					})
					.catch((error) => {});
			},
			getTeachingClass() {
				api.getTeachingClass().then((res) => {
					if (res.code == 0) {
						this.options = res.data;
					}
				});
			},
			add_project() {
				this.params = {
					professionalId: this.professional,
				};
				api.projectList(this.params).then((res) => {
					if (res.code == 0) {
						res.data.records.forEach(function(item) {
							item.checkList = [];
						});
						this.projectList = res.data.records;
						console.log("项目列表", this.projectList);
					}
				});
			},
			addstu(item) {
				this.$set(item,'innerVisible',true)
				console.log(item)
				this.checkAll = false
				this.isIndeterminate = false
				this.checkedStus = []
				this.getStuList(item)
			},
			getStuList(item){
				let params = {
					param: this.mobileName,
					companyId: this.id,
					pageSize: 100,
					pageNo: 1,
				};
				api.companyUserList(params).then((res) => {
					if (res.code == 0) {
						let arr = []
						res.data.list.forEach(item=>{
							let obj = {}
							obj.studentName = item.studentName
							obj.studentUserId = item.studentUserId
							arr.push(obj)
						})
						this.stuList = arr;
						let arr1 = []
						if(item.checkList.length){
							item.checkList.forEach(item=>{
								arr1.push(item.studentUserId)
							})
							this.checkedStus = arr1
							if(this.stuList.length == this.checkedStus.length){
								this.isIndeterminate = false;
								this.checkAll = true;
							}else{
								this.isIndeterminate = true;
								this.checkAll = false;
							}
						}else{
							this.checkedStus = []
							this.isIndeterminate = false;
							this.checkAll = false;
						}
					}
				})
			},
			delstu(q) {
				this.params = [q.id];
				api.delCompanyStaff(this.params).then((res) => {
					if (res.code == 0) {
						this.personnelManagementFuntion(this.id);
					}
				});
			},
			addStuProject() {
				this.dialogVisible = false;
				let param = [];
				this.subjectIds.forEach((item, key) => {
					let o = {
						companyId: this.id,
						ids: [],
						projectId: item.projectId,
					};
					item.checkList.forEach((citem) => {
						o.ids.push(citem.studentUserId);
					});
					param.push(o);
				});

				console.log("---o-o---", param);

				api.distribute(param).then((res) => {
					if (res.code == 0) {
						this.personnelManagementFuntion(this.id);
					}
				});
			},
			//分页
			classCompanySizeChange(val) {
				this.totalObj.pageSize = val;
				this.personnelManagementFuntion();
			},
			classCompanyCurrentChange(val) {
				this.totalObj.currentPage = val;
				this.personnelManagementFuntion();
			},
			back() {
				this.$router.go(-1)
			},
			// 处理初始化状态
			handleStatus(status){
				let str = ''
				switch (status){
					case 0:
						str = '待初始化'
						break;
					case 1:
						str = '初始化中'
						break;
					case 2:
						str = '初始化成功'
						break;
					case 3:
						str = '初始化失败'
						break;
					case 4:
						str = '初始化中'
						break;
					default:
						break;
				}
				return str
			},
			cut(val) {
				this.$store.state.cutNum = val
			},
			selected(row){
				if(row.status == 2){
					return false
				}else{
					return true
				}
			},
			handleCheckAllChange(val) {
				if(val){
					this.checkedStus = [];
					this.stuList.forEach(item=>{
					  this.checkedStus.push(item.studentUserId);
					})
				}else{
					this.checkAll = false;
					this.checkedStus = [];
				}
				this.isIndeterminate = false;
			},
			handleCheckedChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.stuList.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.stuList.length;
			},
			handleStu(type,item){
				if(type){
					let arr = []
					this.checkedStus.forEach(item=>{
						this.stuList.forEach(val=>{
							let obj = {}
							if(item == val.studentUserId){
								obj.studentUserId = val.studentUserId
								obj.studentName = val.studentName
								arr.push(obj)
							}
						})

					})
					item.checkList = arr
					this.$set(item,'innerVisible',false)
				}else{
					this.$set(item,'innerVisible',false)
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	.inner_wrap {
		.stu_list {
			max-height: 400px;
			overflow: auto;
			margin-top: 10px;
			.el-checkbox-group {
				.el-checkbox {
					line-height: 30px;
				}
			}
		}
	}
</style>

<style lang="scss">
	.marketingProjectEditor {
		cursor: default;
		width: 100%;
		padding: 20px;
		height: calc(100% - 90px);
		display: flex;
		justify-content: center;
		background: #f5f5f7;

		.realTaskmenu {
			width: 200px;
		}

		.userTable {
			width: 1062px;
			margin-left: 20px;
			position: relative;

			.userTableBtn {
				display: flex;
				justify-content: space-between;
				background: #ffffff;
				margin: 10px 0px;
				padding: 0px 15px;
			}

			#tableId {
				padding: 0px 15px;
				background: #f9f9fa;
				max-height: calc(100% - 120px);
				overflow-y: auto;
				min-height: calc(100% - 120px);
			}
		}

		.upload_custom {

			.el-upload--picture-card,
			.el-upload-list__item {
				width: 80px;
				height: 80px;
			}

			.el-input__icon {
				line-height: 80px;
			}

			.el-upload {
				line-height: 80px;
			}
		}

		/*.el-upload-list__item-thumbnail{*/
		/*    width: 80px!important;*/
		/*    height: 80px!important;*/
		/*  }*/

		/*.el-input__icon{*/
		/*  margin-top: 18px;*/
		/*}*/

		/*.el-select__caret {*/

		/*}*/

		.seach {
			display: flex;
			justify-content: space-around;
			align-items: center;
			margin: 10px;
		}

		.sudent-content {
			display: flex;

			.el-input {
				width: 150px;
				float: none;

				.el-input__inner {
					height: 28px;
				}
			}

			.el-input--suffix {
				margin-right: 10px;
			}

			.selected {
				width: 450px;
				border: 1px solid #e2e2e2;
			}

			.box_button {
				display: flex;
				padding: 0;
				flex-direction: column;
				justify-content: center;

				.el-button {
					margin: 10px;
				}
			}
		}

		.el-dialog {
			border-radius: 25px;
		}

		.box-card {
			height: 190px;
			width: 90%;
			margin: 30px 30px 0 30px;
		}

		.card_text span {
			display: none;
			text-decoration: none;
		}

		.card_text:hover span {
			display: block;

			position: absolute;

			top: 0;

			left: 0;

			color: black;

			font-size: 14px;
		}

		.card_text img {
			transition: all 1s ease;
		}

		.card_text:hover img {
			filter: blur(5px);
		}

		.el-card__body,
		.el-main {
			padding: 0px !important;
			margin: 10px 10px 5px 12.5px;
		}

		.text {
			font-size: 14px;
		}

		.A p {
			color: #0e56ad;
		}

		.selectePages {
			background: #f5f5f7;
			height: 50px;
			width: 100%;
			text-align: right;
			margin-top: 20px;
			position: absolute;
			bottom: 0px;
			right: 0px;
		}

		.selecteStudentPages {
			padding: 4px 30px;
		}

	}
</style>



// WEBPACK FOOTER //
// src/views/newRealTask/components/marketingProjectEditor.vue